import actionCable from "actioncable";

import { WS_NOTIF, API_DEV } from "constants/api";

import { header, handleAPIResult, serialize } from "utils";

const notifier = { cable: null, subscriptions: [] };

export const notificationService = {
  createConsumer,
  ensureConsumer,
  destroy,
  list,
  send,
  subscribe,
  subscribeAll,
  unsubscribe,
  notifs_tv,
  powerBiUrl,
};

// nothing works in this service without calling this function first
function createConsumer(user_id) {
  // console.log('-- CONSUMMER CREATION START --');
  notifier.cable = actionCable.createConsumer(WS_NOTIF + "/notification");
  notifier.user_id = user_id;
  // console.log('ActionCable Consummer :', notifier.cable);
  // console.log('-- CONSUMMER CREATION END --');
  return notifier.cable;
}

// Reuse an already-open consumer (SideNav's) rather than replacing it: replacing
// it would leave the existing subscriptions orphaned.
function ensureConsumer(user_id) {
  return notifier.cable || createConsumer(user_id);
}

// Like `subscribe`, but it keeps the current user's own messages and stays out of
// the shared subscriptions list, so unsubscribing here can't tear down SideNav's.
function subscribeAll(onReceive) {
  verifyConsumer();
  return notifier.cable.subscriptions.create(
    { channel: "NotificationChannel", user_id: notifier.user_id },
    { received: (data) => onReceive && onReceive(data) },
  );
}

function send({ message }, to_user_id) {
  verifyConsumer();
  let identifier = { channel: "NotificationChannel", user_id: notifier.user_id };
  let payload = {
    command: "message",
    identifier: JSON.stringify(identifier),
    data: JSON.stringify({ type: "message", message, to_user_id }),
  };
  notifier.cable.send(payload);
}

function subscribe(onReceive, onConnect, onDisconnect) {
  // console.log('-- SUBSCRIBTION START --');
  // console.log('ActionCable Consummer :', notifier.cable);

  verifyConsumer();
  const sub = notifier.cable.subscriptions.create(
    {
      channel: "NotificationChannel",
      user_id: notifier.user_id,
    },
    {
      connected: () => {
        // console.debug('cable connected')
        onConnect && onConnect();
      },
      disconnected: () => {
        // console.debug('cable disconnected')
        onDisconnect && onDisconnect();
      },
      received: (data) => {
        // console.debug('cable notification:', data)
        if (data.user_id != notifier.user_id) onReceive && onReceive(data);
      },
    },
  );

  // console.log('Created subscriber :', sub);
  // console.log('-- SUBSCRIBTION END --');
  notifier.subscriptions.push(sub);
  return sub;
}

function unsubscribe() {
  console.log("-- UNSUBSCRIBTION START --");
  verifyConsumer();
  for (let i = 0; i < notifier.subscriptions.length; ++i) {
    notifier.subscriptions[i].unsubscribe();
  }
  notifier.subscriptions = [];
  // console.log('-- SUBSCRIBTION END --');
}

function destroy() {
  verifyConsumer();
  notifier.user_id = null;
  notifier.cable.disconnect();
  notifier.cable = null;
  // console.log('cable disconnecting...')
}

function list(filters, order = "created_at") {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs = serialize({ order_by: order, order_direction: "DESC", ...filters });
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/audits?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve({
          unseen_count: result.unseen_count,
          page: result.page,
          per_page: result.per_page,
          total: result.total,
          data: result.data.map((r) => ({
            ...r.audited_changes,
            date: r.created_at,
            type: r.auditable_type,
            action_type: r.action,
            action_id: r.auditable_id,
            id: r.id,
            user_id: r.user?.id,
            user_name: r.user?.name + " " + r.user?.surname,
          })),
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function notifs_tv() {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs = serialize({ order_by: "created_at", order_direction: "DESC" });
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/audits/?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve({
          unseen_count: result.unseen_count,
          page: result.page,
          per_page: result.per_page,
          total: result.total,
          data: result.data.map((r) => ({
            ...r.audited_changes,
            date: r.created_at,
            type: r.auditable_type,
            action_type: r.action,
            action_id: r.auditable_id,
            id: r.id,
            user_id: r.user ? r.user.id : "99",
            user_name: r.user ? r.user.name + " " + r.user.surname : "Utilisateur Visiteur",
            user_avatar_url:
              r.user && r.user.documents[0] ? r.user.documents[0].url.thumb.url : null,
          })),
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function verifyConsumer() {
  if (!notifier.cable) {
    throw "No consumer created for notifications. Call `createConsumer` first.";
  }
}

//Retourne l'url pour power bi
function powerBiUrl() {
  return API_DEV + "/audits";
}
